var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{staticClass:"content"},[_vm._l((_vm.components),function(component){return [_c(component,{key:component,tag:"component"})]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }